import { EditorDetailModel } from './editor.detail.model';

export class PagedEditorDetailModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: Array<EditorDetailModel>;

    constructor() {
        this.items = new Array<EditorDetailModel>();
    }
}
